module.exports = __webpack_public_path__ + "img/SEJ enventos_regresar.a9895791.svg";